
const qualities=[{id:1,name:"Normal"},{id:2,name:"Good"},{id:3,name:"Oustanding"},{id:4,name:"Excellent"},{id:5,name:"Masterpiece"}]

function getQualityName(quality){
    let qualityFound = qualities.filter(qualityObj => qualityObj.id === quality)
    return qualityFound[0].name
}

  export default getQualityName;